// extracted by mini-css-extract-plugin
module.exports = {"Container":"Pagination-module--Container--TVX2S","PageNumber":"Pagination-module--PageNumber--1kKTN","PageActive":"Pagination-module--PageActive--TBQVe"};